import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { AdminTabs } from '~/components/Admin/AdminTabs';
import { Banner } from './Banner';
import { Macl } from './Macl';
import { ReportYear } from './ReportYear';
import { Reports } from './Reports';
import { Users } from './Users';

interface AdminProps {
    location: Location;
    match: { url: string };
}
export function Admin({ location, match }: AdminProps) {
    return location.pathname === '/admin' ? (
        <Redirect to={{ pathname: `${match.url}/users` }} />
    ) : (
        <div className="container">
            <AdminTabs />
            <Switch>
                <Route path={`${match.url}/macl`} component={Macl} exact />
                <Route path={`${match.url}/reports`} component={Reports} exact />
                <Route path={`${match.url}/reportyear`} component={ReportYear} exact />
                <Route path={`${match.url}/banner`} component={Banner} exact />
                <Route path={`${match.url}/users`} component={Users} exact />
            </Switch>
        </div>
    );
}
